import {useEffect} from "react";
import {useMembers} from "../../hooks/UseMembers";
import {useSerialTranslators} from "../../hooks/UseSerialTranslators";
import {EditMember} from "../members/EditMember";
import {EmptyMember} from "../members/EmptyMember";

export function EditSerialTranslators(props) {
    const user = props.user;
    const serialId = props.serialId;
    const membersHook = useMembers();
    const serialTranslatorsHook = useSerialTranslators();

    useEffect(() => {
        membersHook.loadMembers(user.token, true);
    }, [user]);

    useEffect(() => {
        if (serialId)
            serialTranslatorsHook.loadSerialTranslators(user.token, serialId);
    }, [user, serialId]);

    const onSaveClicked = async (data) => {
        await serialTranslatorsHook.createSerialTranslator(user.token, serialId, data.memberId);
    };

    const onDeleteClicked = async (id) => {
        await serialTranslatorsHook.deleteSerialTranslator(user.token, serialId, id);
    }

    const allMembers = membersHook.members || [];
    const currentTranslatorsRaw = serialTranslatorsHook.serialTranslators || [];

    if (membersHook.loading || serialTranslatorsHook.loading) {
        return <div style={{ textAlign: 'center', padding: '10px', color: '#6b7280' }}>Завантаження...</div>;
    }

    const availableMembers = allMembers
        .filter(m => !currentTranslatorsRaw.some(st => st.memberId === m.id))
        .sort((a, b) => (a.nickName || "").localeCompare(b.nickName || ""));

    const memberElements = currentTranslatorsRaw.map(st => {
        const fullMemberData = allMembers.find(m => m.id === st.memberId);

        return (
            <EditMember
                member={st.member || fullMemberData || { nickName: 'ID: ' + st.memberId }}
                key={st.memberId}
                onDeleteClicked={() => onDeleteClicked(st.memberId)}
            />
        );
    });

    return (
        <div style={{ width: '100%' }}>
            <div style={{ marginBottom: '15px' }}>
                <EmptyMember members={availableMembers} onSaveClicked={onSaveClicked}/>
            </div>

            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px',
                minHeight: '40px',
                padding: '10px',
                backgroundColor: '#f9fafb',
                borderRadius: '8px',
                border: '1px solid #f3f4f6'
            }}>
                {memberElements.length > 0 ? (
                    memberElements
                ) : (
                    <span style={{ color: '#9ca3af', fontSize: '13px' }}>Ще не додано</span>
                )}
            </div>
        </div>
    );
}